import React from 'react';
import DressCodeCell from './DressCodeCell';
import {
  GENDERS,
  AGE_CATEGORIES,
  GENDER_LABELS,
  AGE_CATEGORY_LABELS,
  dressCodeGridKey,
} from '@/types/dressCode.types';
import type {
  Gender,
  AgeCategory,
  DressCodeGrid,
  UpdateDressCodeDto,
} from '@/types/dressCode.types';

interface Props {
  grid: DressCodeGrid;
  celebrationId: number;
  onCellChange: (
    gender: Gender,
    ageCategory: AgeCategory,
    dto: UpdateDressCodeDto & { description: string }
  ) => void;
  onCopyToAll: (gender: Gender, ageCategory: AgeCategory) => void;
  disabled?: boolean;
}

const DressCodeGrid: React.FC<Props> = ({
  grid,
  celebrationId,
  onCellChange,
  onCopyToAll,
  disabled = false,
}) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse min-w-[600px]">
        <thead>
          <tr>
            <th className="text-left text-xs text-gray-500 font-medium py-2 pr-3 w-36 min-w-[9rem]">
              Age Group
            </th>
            {GENDERS.map(g => (
              <th
                key={g}
                className="text-center text-xs font-medium text-gray-700 py-2 px-2"
              >
                {GENDER_LABELS[g]}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {AGE_CATEGORIES.map(age => (
            <tr key={age} className="align-top">
              <td className="py-2 pr-3">
                <span className="text-xs font-medium text-gray-700 leading-tight">
                  {AGE_CATEGORY_LABELS[age]}
                </span>
              </td>
              {GENDERS.map(g => {
                const key = dressCodeGridKey(g, age);
                const entry = grid[key];
                return (
                  <td key={g} className="py-2 px-2 align-top">
                    <DressCodeCell
                      gender={g}
                      ageCategory={age}
                      entry={entry}
                      onChange={onCellChange}
                      onCopyToAll={onCopyToAll}
                      celebrationId={celebrationId}
                      disabled={disabled}
                    />
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DressCodeGrid;
